import { Grid } from '@material-ui/core'
import React from 'react'
import FetchData from '../../../shared/fetchData'
import { updateObject } from '../../../shared/utility'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import DatePicker from '../../UI/DatePicker/DatePicker'
import Input from '../../UI/Input/Input'
import Select from '../../UI/Select/Select'
import './InvoiceForm.css'

const InvoiceForm = (props) => {

    const [seller, setSeller] = React.useState('')
    const [buyer, setBuyer] = React.useState('')
    const [registerDate, setRegisterDate] = React.useState('')
    const [fromDate, setFromDate] = React.useState('')
    const [toDate, setToDate] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [invalidSelect, setInvalidSelect] = React.useState(false)
    const [invalidDate, setInvalidDate] = React.useState(false)
    const [creditChangeTypes, setCreditChangeTypes,] = React.useState([])
    const [creditChangeType, setCreditChangeType] = React.useState([])
    const [invoice, setInvoice] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                placeholder: 'شرح صورتحساب'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        var raw = JSON.stringify({
            "version": "mtpx001"
        })
        var url = 'management/api/v1/creditchanges/getCreditChangeTypes'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setCreditChangeTypes(result.creditChangeTypes)
                }
            })
            .catch(error => setLoading(false))
        const defaultUnit = props.units.filter(u => u.id == '1')
        if (defaultUnit !== null && defaultUnit.length !== 0) {
            setSeller({
                value: defaultUnit[0].id,
                label: defaultUnit[0].unitName
            })
        }
    }, [])
    const changeSeller = selectedOption => {
        setSeller(selectedOption)
    }
    const changeBuyer = selectedOption => {
        setBuyer(selectedOption)
    }
    const registerDateChange = (unix, formatted) => {
        setRegisterDate(formatted)
    }
    const fromDateChange = (unix, formatted) => {
        setFromDate(formatted)
    }
    const toDateChange = (unix, formatted) => {
        setToDate(formatted)
    }
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(invoice, {
            [controlName]: updateObject(invoice[controlName], {
                value: event.target.value,
                valid: true
            })
        });
        setInvoice(updatedControls)
    }

    const InvoiceSubmit = (event) => {
        setInvalidSelect(false)
        setInvalidDate(false)
        let valid = true
        const invc = invoice
        for (let key in invc) {
            if (invc[key].value == null || invc[key].value == '') {
                invc[key].valid = false
                valid = false
            }
        }
        if (creditChangeType == null || creditChangeType.length == 0) {
            valid = false
            props.showInvoiceAlert(event, true, 'لطفا اطلاعات فرم را کامل کنید')
        }
        if (!valid) {
            setInvoice(invc)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
            if (seller == null || seller == ''
                || buyer == null || buyer == ''
            ) {
                setInvalidSelect(true)
            }
            if (registerDate == null || registerDate == ''
                || fromDate == null || fromDate == ''
                || toDate == null || toDate == ''
            ) {
                setInvalidDate(true)
            }
        } else {
            var raw = JSON.stringify({
                "invoice": {
                    "description": invoice.description.value,
                    "registerDate": registerDate,
                    "fromDate": fromDate,
                    "toDate": toDate,
                    "creditChangeTypes": creditChangeType.join(","),
                    "seller": {
                        "id": seller != null && seller != '' ? seller.value : ''
                    },
                    "buyer": {
                        "id": buyer != null && buyer != '' ? buyer.value : ''
                    }
                },
                "version": "mtpx001"
            })
            var url = 'management/api/v1/invoices/insertInvoice'
            setLoading(true)
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        props.toggleNewInvoiceForm(event, false)
                    } else if (result.message == 'OVERLAP_DATA') {
                        props.showInvoiceAlert(event, true, 'با سایر صورتحساب ها همپوشانی دارد!')
                    }
                })
                .catch(error => setLoading(false))
        }
    }
    const addCreditChangeType = (event, value) => {
        if (creditChangeType != null && creditChangeType.length != 0 && creditChangeType.includes(value)) {
            let cct = creditChangeType.filter(c => c !== value)
            setCreditChangeType([...cct])
        } else {
            let cct = creditChangeType
            cct.push(value)
            setCreditChangeType([...cct])
        }
    }
    let units = []
    if (props.units != null && props.units.length != 0) {
        props.units.map(k => {
            units.push({
                value: k.id,
                label: k.unitName
            })
        })
    }

    const formElementsArray = [];
    for (let key in invoice) {
        formElementsArray.push({
            id: key,
            config: invoice[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="12 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    let creditTypeList = creditChangeTypes.map(p => {
        return (
            <div className="col-4 mt-2 full-small">
                <label className="container role-text">{p.description}
                    <input type="checkbox"
                        checked={creditChangeType != null && creditChangeType.length != 0 && creditChangeType.includes(p.id)}
                        onChange={(event) => addCreditChangeType(event, p.id)}
                        value={p.id} id="flexCheckDefault" />
                    <span className="checkmark"></span>
                </label>
            </div>
        )
    })
    return (
        <div className='row justify-content-center'>
            <Grid lg={6} md={10} sm={11} xs={11}>
                <ContentForm headetText='صورتحساب'>
                    <div className='invc-frm'>
                        <Select
                            name="form-field-name"
                            value={seller}
                            placeholder="فروشنده"
                            options={units}
                            onChange={changeSeller}
                            col="6 mt-2"
                            className={invalidSelect && (seller == null || seller == '') ? 'invalid-select' : ''}
                        />
                        <div className="col-6"></div>
                        <Select
                            name="form-field-name"
                            value={buyer}
                            placeholder="خریدار"
                            options={units}
                            onChange={changeBuyer}
                            col="6 mt-2"
                            className={invalidSelect && (buyer == null || buyer == '') ? 'invalid-select' : ''}
                        />
                        <DatePicker
                            className={invalidDate && (registerDate == null || registerDate == '') ? 'invalid-date' : ''}
                            change={registerDateChange} col="6 mt-2 hulf-small" value={registerDate} placeHolder="تاریخ ثبت"></DatePicker>
                        <DatePicker
                            className={invalidDate && (fromDate == null || fromDate == '') ? 'invalid-date' : ''}
                            change={fromDateChange} col="6 mt-2 hulf-small" value={fromDate} placeHolder="از تاریخ"></DatePicker>
                        <DatePicker
                            className={invalidDate && (toDate == null || toDate == '') ? 'invalid-date' : ''}
                            change={toDateChange} col="6 mt-2 hulf-small" value={toDate} placeHolder="تا تاریخ"></DatePicker>
                        {form}
                        {creditTypeList}
                    </div>
                    <div className='row justify-content-center w-100 mt-3'>
                        <div className='col-6 text-center'>
                            <Button btnType="General" clicked={(event) => props.toggleNewInvoiceForm(event, false)}>برگشت</Button>
                        </div>
                        <div className='col-6 text-center'>
                            <Button btnType="Success" clicked={InvoiceSubmit}>ثبت</Button>
                        </div>
                    </div>
                </ContentForm>
            </Grid>
        </div>
    )
}

export default InvoiceForm